import { BaseComponent } from '../base-component'
import { isEnterKey } from '../../utils/key'
import { Nullable } from '../../types/common'
import { $el } from 'src/scripts/utils/utils'

const INPUT_SELECTOR = '[data-quantity-input]'

export class QuantityComponent extends BaseComponent {
  input: Nullable<HTMLInputElement>
  prevValue: string
  stockValue: string

  constructor() {
    super()
    this.input = $el(INPUT_SELECTOR, this)
    this.prevValue = this.value
    this.stockValue = this.dataset.stock || '0'
  }

  mountComponent(): void {
    this.updateButtonsDisable()
    this.addListener(this.input, 'keypress', this.handleKeydown)
    this.addListener(this.input, 'input', this.handleInput)
    this.addListener(this.input, 'blur', this.handleBlur)
  }

  handleBlur = (event: KeyboardEvent): void => {
    if (this.input) {
      const target = event.target as HTMLInputElement
      const value = target.value || '0'

      this.input.value = value
      this.updateButtonsDisable()
      this.prevValue = value
    }
  }

  handleKeydown = (event: KeyboardEvent): void => {
    if (this.input && isEnterKey(event)) {
      event.preventDefault()
      this.input.blur()
    }
  }

  handleInput = (event: InputEvent): void => {
    if (this.input) {
      const input = event.target as HTMLInputElement
      const value = input.value

      this.input.value = this.isMoreThanStock ? this.stockValue : value
      this.updateButtonsDisable()
      this.prevValue = value
    }
  }

  inputChange(action: string): void {
    if (this.input) {
      if (action === 'minus') {
        this.input.stepDown()
      } else {
        this.input.stepUp()
      }

      if (+this.prevValue !== +this.value) {
        this.input.dispatchEvent(new Event('change', { bubbles: true }))
      }

      this.updateButtonsDisable()
    }
  }

  updateButtonsDisable(): void {
    this.updateButtonDisabled('minus', this.isLessThanMin)
    this.updateButtonDisabled('plus', this.isMoreThanStock)
  }

  setDisable(isDisabled: boolean): void {
    this.updateButtonDisabled('minus', isDisabled)
    this.updateButtonDisabled('plus', isDisabled)
  }

  updateButtonDisabled(btnType: string, isDisabled: boolean): void {
    const button = $el(`quantity-btn[data-action="${btnType}"]`, this)
    button?.toggleAttribute('disabled', isDisabled)
  }

  get value(): string {
    if (!this.input) {
      return '0'
    }

    return this.input.value
  }

  get isLessThanMin(): boolean {
    if (!this.input) {
      return false
    }

    return +this.value <= +this.input.min
  }

  get isMoreThanStock(): boolean {
    return +this.value >= +this.stockValue
  }
}
